import {ModuleComponent} from "../../js/module-component";

export class ModBlogPostDetail extends ModuleComponent{
    ready(){
        super.ready();

        this.findMember("back-link").click(
            (ev)=>{
                ev.preventDefault();
                window.history.back();
            }
        );
    }
}
